<app-lfsa-card *ngIf="!mostrarFormulario" [innTemplate]="enviarTemplate" [titulo]="'Consulta Factura Electrónica'">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row col-12 ">
      <div class="form-group col-3">
        <app-lfsa-input [control]="formulario.get('fechaInicial')" [id]="'fechaInicial'" [label]="'Fecha Inicial'"
                        [type]="'date'" formControlName="fechaInicial"></app-lfsa-input>
      </div>

      <div class="form-group col-3">
        <app-lfsa-input [control]="formulario.get('fechaFinal')" [id]="'fechaFinal'" [label]="'Fecha Final'"
                        [type]="'date'"
                        formControlName="fechaFinal"></app-lfsa-input>
      </div>

      <div class="form-group col-3">
        <app-lfsa-combo-box [comboBox]="ListcrtStatusDoc" [control]="formulario.get('ctrStatusDoc')" [idOpcion]="'id'"
                            [id]="'ctrStatusDoc'" [label]="'Estado'" [opcion]="'valor'"
                            formControlName="ctrStatusDoc"></app-lfsa-combo-box>
      </div>

      <div class="form-row mb-3"></div>
      <div class="col-3">
        <label>&nbsp;</label>
        <button (click)="buscarParametros()" [disabled]="formulario.invalid" class="btn btn-success btn-block">
          Buscar
        </button>
      </div>
    </div>
  </form>
</ng-template>

<!-- <div class="col-sm-12 animated fadeInRight" *ngIf="!mostrarFormulario">
    <div class="card">
        <div class="card-header">
            <strong>Consulta Factura Electronica</strong>
        </div>
        <div class="card-body">
            <form [formGroup]="formulario" novalidate class="form-group">
                <div class="row col-12 ">
                    <div class="form-group col-3">
                        <app-lfsa-input [label]="'Fecha Inicial'" [type]="'date'" [id]="'fechaInicial'" formControlName="fechaInicial" [control]="formulario.get('fechaInicial')"></app-lfsa-input>
                    </div>

                    <div class="form-group col-3">
                        <app-lfsa-input [label]="'Fecha Final'" [type]="'date'" [id]="'fechaFinal'" formControlName="fechaFinal" [control]="formulario.get('fechaFinal')"></app-lfsa-input>
                    </div>

                    <div class="form-group col-3">
                        <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="ListcrtStatusDoc" formControlName="ctrStatusDoc" [control]="formulario.get('ctrStatusDoc')" [label]="'Estado'" [id]="'ctrStatusDoc'"></app-lfsa-combo-box>
                    </div>

                    <div class="form-row mb-3"></div>
                    <div class="col-3">
                        <label>&nbsp;</label>
                        <button [disabled]="formulario.invalid" class="btn btn-success btn-block" (click)="buscarParametros()"> Buscar </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div> -->


<!-- <br> -->
<app-lfsa-card *ngIf="!mostrarFormulario" [innTemplate]="enviarTemplateResport" [titulo]="'Detalle Factura Pendiente'">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row col-12 ">
      <div class="col-3">
        <app-lfsa-input [control]="formulario.get('caja')" [id]="'caja'" [label]="'Orden'"
                        [placeholder]="'Ingrese N°Orden'"
                        [type]="'number'" formControlName="caja"></app-lfsa-input>
      </div>
      <div class="col-3">
        <label>&nbsp;</label>
        <button (click)="getSelectedRows()" class="btn btn-outline-primary btn-block">Cambiar Orden</button>
      </div>
    </div>
  </form>
  <hr>
  <div class="container">
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div *ngIf="!loading">
      <div *ngIf="listaVacia" class="alert alert-danger animated fadeInRight" role="alert">
        No existen datos para la lista documentos.
      </div>
      <div *ngIf="!listaVacia">
        <div class="row">
          <div class="col ">
            <input #quickFilter (keyup)="onQuickFilterChanged() " [(ngModel)]="textoBuscar "
                   class="form-control float-left " id="quickFilter " placeholder="Buscar.. "/>
          </div>
        </div>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs "
                         [frameworkComponents]="frameworkComponents " [pagination]="true"
                         [rowData]="rowData " [rowSelection]="rowSelection" class="ag-theme-material mt-3"
                         style="width: 100%; height: 400px;">
        </ag-grid-angular>
      </div>
    </div>
  </div>
</ng-template>

<!-- <div class="col-sm-12 animated fadeInRight" *ngIf="!mostrarFormulario">
    <div class="card">
        <div class="card-header">
            <strong>Detalle Factura Pendiente</strong>
        </div>
        <div class="card-body">
            <form [formGroup]="formulario" novalidate class="form-group">
                <div class="row col-12 ">
                    <div class="form-row col-3">
                        <app-lfsa-input [placeholder]="'Orden'" [type]="'number'" [label]="'Orden'" [id]="'caja'" formControlName="caja" [control]="formulario.get('caja')"></app-lfsa-input>
                    </div>
                    <div class="form-row col-3">
                        <label>&nbsp;</label>
                        <button (click)="getSelectedRows()" class="btn btn-outline-primary btn-block">Cambiar Orden</button>
                    </div>
                </div>
            </form>
            <hr>
            <div class="container">
                <div class="row">
                    <div class="col ">
                        <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter/>
                    </div>
                </div>
                <ag-grid-angular #agGrid style="width: 100%; height: 400px;" class="ag-theme-material mt-3" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs " [rowSelection]="rowSelection" [rowData]="rowData " [pagination]="true" (gridReady)="onGridReady($event)">
                </ag-grid-angular>
            </div>

        </div>
    </div>
</div> -->
